import angular from 'angular';

class modalJsonCtrl {
    /* @ngInject */
    constructor() {}

    $onInit() {
        this.jsonPretty = JSON.stringify(this.resolve.json, null, 3);
        this.title = this.resolve.title;
    }

    close() {
        this.modalInstance.dismiss('close');
    }
}

angular.module('app.payment').component('modalJson', {
    templateUrl: require('./modal-json.html'),
    controller: modalJsonCtrl,
    bindings: {
        resolve: '<',
        modalInstance: '<',
    },
});
